<div class="build-number">v:{{ buildNumber }}</div>
<a href="https://www.sampleliste.de/impressum">Impressum</a> | <a href="https://www.sampleliste.de/agb">AGB</a> |
<a href="https://www.sampleliste.de/datenschutz">Datenschutz</a>
<!-- <a href="https://www.youtube.com/channel/UCFp9ic4q40BaZy2-gyQ58ZA">Hilfe Videos</a> -->
